<!--
    The input group for a variable belonging to an ENTER_NUMBER question on a QuestionForm.
-->
<template>
  <b-container class="survey-results-filter-slider">
    <div
      class="survey-results-filter-slider__slider"
      ref="slider"
      :disabled="disabled"
    />

    <div class="survey-results-filter-slider__value">
      <span class="survey-results-filter-slider__value-prefix">
        {{ variable ? variable.prefix : '' }}
      </span>
      <span class="survey-results-filter-slider__value-value">
        {{ min }} - {{ max }}
      </span>
      <span class="survey-results-filter-slider__value-suffix">
        {{ variable ? variable.suffix : '' }}
      </span>
    </div>
  </b-container>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import noUiSlider from 'nouislider';

export default {
  name: 'surveyResultsFilterSlider',
  props: {
    uid: String, // unique ID to use in the DOM ID of the slider element
    // values: Array,       // initial values (these are updated indirectly via the update handler below)
    onUpdate: Function, // callback to store the updated values when the slider is moved
    variable: Object,
    min: Number,
    max: Number,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      sliderElt: null,
      slider: null,
    };
  },
  mounted: function () {
    const vm = this;
    this.sliderElt = this.$refs['slider'];
    const step = this.variable.step || 1;
    const rangeMin = this.variable.min || 0;
    const rangeMax = this.variable.max || rangeMin + step;
    // initialize slider
    vm.slider = noUiSlider.create(this.sliderElt, {
      start: [this.vMin, this.vMax],
      connect: [false, true, false],
      step: this.step,
      range: {
        min: rangeMin,
        max: rangeMax,
      },
    });

    // handle slider updates
    if (this.sliderElt) {
      this.sliderElt.noUiSlider.on('update', function (vals, handle) {
        // NB: for some reason updating the elements of this.values directly
        // doesn't work, so we update them indirectly in the onUpdate handler...
        if (vm.onUpdate) {
          vm.onUpdate(vm.uid, parseInt(vals[0]), parseInt(vals[1]));
        }
      });
    }
  },
  computed: {
    step: function () {
      return this.variable.step ? this.variable.step : 1;
    },
    vMin: function () {
      return this.min || this.variable.min || 0;
    },
    vMax: function () {
      return this.max || this.variable.max || this.min + this.step;
    },
  },
};
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">
.survey-results-filter-slider {
  padding-right: 30px;
}

.survey-results-filter-slider__slider {
  margin: 0;
}

.survey-results-filter-slider__value {
  text-align: center;
  margin-top: 10px;
}

// noUiSlider overrides

.survey-results-filter-slider {
  .noUi-handle {
    height: 24px;
    width: 20px;
  }

  .noUi-horizontal {
    height: 14px;
  }

  .noUi-pips {
    display: none;
  }

  .noUi-handle::before {
    left: 7px;
    top: 6px;
    height: 10px;
  }

  .noUi-handle::after {
    left: 11px;
    top: 6px;
    height: 10px;
  }
}
</style>
